/* tslint:disable */
/**
 * Permissions Plugin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * A ShareFile User role
 * @export
 * @enum {string}
 */
export var UserRole;
(function (UserRole) {
    UserRole["Employee"] = "Employee";
    UserRole["Client"] = "Client";
})(UserRole || (UserRole = {}));
export function UserRoleFromJSON(json) {
    return UserRoleFromJSONTyped(json, false);
}
export function UserRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function UserRoleToJSON(value) {
    return value;
}
//# sourceMappingURL=UserRole.js.map